// @flow
import type { DayOfWeek } from 'common/domain/DayOfWeek';
import type { Dispatch, GetState } from '../../../types/Store';
import { getToken, getStation } from '../../authentication/session/selectors/sessionSelectors';
import { getSpotSchedule } from '../selectors/salesInventorySelectors';
import SalesInventoryAPI from '../services/SalesInventoryAPI';
import SpotScheduleTimeSlot from '../domain/SpotScheduleTimeSlot';

export const UPDATE_SPOT_SCHEDULE_TIMESLOT_SUCCESS = 'salesInventory/UPDATE_SPOT_SCHEDULE_TIMESLOT_SUCCESS';
export const UPDATE_SPOT_SCHEDULE_TIMESLOT_FAILED = 'salesInventory/UPDATE_SPOT_SCHEDULE_TIMESLOT_FAILED';
export const ADD_SPOT_SCHEDULE_TIMESLOT_SUCCESS = 'salesInventory/ADD_SPOT_SCHEDULE_TIMESLOT_SUCCESS';
export const ADD_SPOT_SCHEDULE_TIMESLOT_FAILED = 'salesInventory/ADD_SPOT_SCHEDULE_TIMESLOT_FAILED';
export const REMOVE_SPOT_SCHEDULE_TIMESLOT = 'salesInventory/REMOVE_SPOT_SCHEDULE_TIMESLOT';

export const FETCH_SPOT_SCHEDULE = 'salesInventory/FETCH_SPOT_SCHEDULE';
export const FETCH_SPOT_SCHEDULE_SUCCESS = 'salesInventory/FETCH_SPOT_SCHEDULE_SUCCESS';
export const FETCH_SPOT_SCHEDULE_FAILED = 'salesInventory/FETCH_SPOT_SCHEDULE_FAILED';

export const UPDATE_SPOT_SCHEDULE = 'salesInventory/UPDATE_SPOT_SCHEDULE';
export const UPDATE_SPOT_SCHEDULE_SUCCESS = 'salesInventory/UPDATE_SPOT_SCHEDULE_SUCCESS';
export const UPDATE_SPOT_SCHEDULE_FAILED = 'salesInventory/UPDATE_SPOT_SCHEDULE_FAILED';

export const updateSpotScheduleTimeSlot = (day: DayOfWeek, oldTimeSlot: SpotScheduleTimeSlot, newTimeSlot: SpotScheduleTimeSlot): Object => {
  return async (dispatch: Dispatch, getState: GetState) => {
    try {
      const schedule = getSpotSchedule(getState());
      const newSchedule = schedule.updateTimeSlot(day, oldTimeSlot, newTimeSlot);

      dispatch({ type: UPDATE_SPOT_SCHEDULE_TIMESLOT_SUCCESS, spotSchedule: newSchedule });
    } catch (error) {
      dispatch({ type: UPDATE_SPOT_SCHEDULE_TIMESLOT_FAILED, error });
    }
  };
};

export const addSpotScheduleTimeSlot = (day: DayOfWeek, timeSlot: SpotScheduleTimeSlot): Object => {
  return async (dispatch: Dispatch, getState: GetState) => {
    try {
      const schedule = getSpotSchedule(getState());
      const newSchedule = schedule.addTimeSlot(day, timeSlot);

      dispatch({ type: ADD_SPOT_SCHEDULE_TIMESLOT_SUCCESS, spotSchedule: newSchedule });
    } catch (error) {
      dispatch({ type: ADD_SPOT_SCHEDULE_TIMESLOT_FAILED, error });
    }
  };
};

export const removeSpotScheduleTimeSlot = (day: DayOfWeek, timeSlot: SpotScheduleTimeSlot): Object => {
  return async (dispatch: Dispatch, getState: GetState) => {
    const schedule = getSpotSchedule(getState());
    const newSchedule = schedule.removeTimeSlot(day, timeSlot);

    dispatch({ type: REMOVE_SPOT_SCHEDULE_TIMESLOT, spotSchedule: newSchedule });
  };
};

export const fetchSpotSchedule = (): any => {
  return async (dispatch: Dispatch, getState: GetState) => {
    dispatch({ type: FETCH_SPOT_SCHEDULE });

    try {
      const token = getToken(getState());
      const radio = getStation(getState());

      const spotSchedule = await SalesInventoryAPI.fetchSpotSchedule(token, radio);

      dispatch({ type: FETCH_SPOT_SCHEDULE_SUCCESS, spotSchedule });
    } catch (error) {
      dispatch({ type: FETCH_SPOT_SCHEDULE_FAILED, error });
    }
  };
};

export const updateSpotSchedule = (): any => {
  return async (dispatch: Dispatch, getState: GetState) => {
    dispatch({ type: UPDATE_SPOT_SCHEDULE });

    try {
      const token = getToken(getState());
      const radio = getStation(getState());
      const schedule = getSpotSchedule(getState());

      await SalesInventoryAPI.updateSpotSchedule(token, radio, schedule);

      dispatch({ type: UPDATE_SPOT_SCHEDULE_SUCCESS });
    } catch (error) {
      dispatch({ type: UPDATE_SPOT_SCHEDULE_FAILED, error });
    }
  };
};



// WEBPACK FOOTER //
// ./src/statsradio/modules/salesInventory/actions/salesInventoryActions.js